import { css } from '@emotion/react'
import { Button, Icon, Text } from 'bold-ui'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContainer } from 'components/layout/PageContainer'
import { useFlags } from 'config/useFlagsContext'
import { useBuscaDetailCidadaoQuery } from 'graphql/hooks.generated'
import { useUrlQueryParams } from 'hooks/useUrlQueryParams'
import qs from 'qs'
import { Fragment } from 'react'
import { useHistory, useLocation, useRouteMatch } from 'react-router'

import { CidadaoBotaoRetornarUrlParams, CidadaoUrlParams } from '../types/cidadao-urlParams'
import { CidadaoCabecalhoSection } from './components/CidadaoCabecalhoSection'
import { CidadaoTabSection } from './components/CidadaoTabSection'

interface UrlParams {
  cidadaoId: string
}

export function CidadaoVisualizacaoView() {
  const match = useRouteMatch<UrlParams>()
  const location = useLocation()
  const history = useHistory()
  const { data } = useBuscaDetailCidadaoQuery({ variables: { id: match.params.cidadaoId } })

  const { PILOTO_PRONTUARIO_FAMILIAR_ENABLED } = useFlags()

  const { callbackUrl, callbackText } = useUrlQueryParams<CidadaoBotaoRetornarUrlParams>()
  const showBotaoRetornar = PILOTO_PRONTUARIO_FAMILIAR_ENABLED && !!callbackUrl

  const cidadaoUrlParams: CidadaoUrlParams = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  })

  const handleClickRetornar = () => {
    if (callbackUrl) {
      history.push(callbackUrl)
    }
  }

  const showActionButtons = !cidadaoUrlParams.callbackUrl

  return (
    <Fragment>
      <Breadcrumb title='Visualização do cadastro' />
      {data?.cidadao && (
        <Fragment>
          <PageContainer fluid>
            {showBotaoRetornar && (
              <Button
                kind='primary'
                skin='outline'
                size='small'
                style={css`
                  margin-top: 0.5rem;
                `}
                onClick={handleClickRetornar}
              >
                <Icon
                  icon='angleLeft'
                  style={css`
                    margin-right: 0.5rem;
                  `}
                />
                <Text color='info'>{callbackText}</Text>
              </Button>
            )}

            <CidadaoCabecalhoSection
              cidadao={data.cidadao}
              sizeBotaoAtualizar='medium'
              botaoExcluirCidadao={showActionButtons}
              botaoSelecionar={!showActionButtons}
              callbackUrl={cidadaoUrlParams.callbackUrl}
              callbackParams={cidadaoUrlParams.callbackParams}
              cadImovelCallBackParams={cidadaoUrlParams.cadImovelUrlParams}
              botaoRetornar={showBotaoRetornar}
            />
          </PageContainer>

          <CidadaoTabSection cidadao={data.cidadao} />
        </Fragment>
      )}
    </Fragment>
  )
}
